import type { WeaponDef } from '../../sim/defs';
import { PbMode } from '../../sim/pools/BulletPool';
import { Stat } from '../../sim/stats';

/** A04 — PERFORANT. « Rounds qui TRAVERSENT une file d'ennemis »
 *  (nœud `arme-perforant`, ouvert par « 400 ennemis dans une run »).
 *
 *  10 volées/s × 2 projectiles × 10 dégâts = 200 DPS — le MÊME nombre que le
 *  VULCAN, au chiffre près. Le levier n'est jamais le débit.
 *
 *  ── Un vrai TYPE de balle : la PERFORATION du moteur ──────────────────────
 *  Ses balles sont marquées `PbMode.Pierce` : elles SURVIVENT au contact et sont
 *  traitées par la passe persistante de `collisionSystem`, exactement comme les
 *  Scies orbitales. Là où la perforation du FAISCEAU est ÉMERGENTE (une colonne
 *  dense dont chaque projectile meurt sur sa cible), celle-ci est RÉELLE : un
 *  seul projectile traverse plusieurs corps. Aucune ligne de moteur nouvelle —
 *  la conduite existe déjà pour les secondaires.
 *
 *  ── ⚠️ Ce qui l'empêche d'être un power creep : DEUX bornes ────────────────
 *  Une balle qui touche N ennemis multiplierait mécaniquement son DPS par N. Deux
 *  garde-fous, tous deux réservés au tir primaire, le tiennent :
 *    · un BUDGET de contacts court (`PRIMARY_PIERCE_HITS` = 3, dans playerSystem) ;
 *    · une DÉCROISSANCE de dégâts par contact (`PRIMARY_PIERCE_FALLOFF` = 0,6,
 *      dans collisionSystem) : la 2ᵉ cible reçoit 60 %, la 3ᵉ 36 %.
 *  Une file de trois reçoit donc 1,96× le mono-cible, jamais 3×. C'est la valeur
 *  que borne `tests/balance/multicible.test.ts`. Les secondaires perforantes,
 *  elles, ne sont PAS décrues — leur budget de contacts et `validateSecondaries`
 *  suffisent.
 *
 *  ── La contrepartie : des rounds 25 % plus FINS ───────────────────────────
 *  La perforation ne vaut que sur une file bien ALIGNÉE ; le round plus fin rend
 *  cet alignement moins pardonnant. L'arme peuple donc l'axe « traverse les files
 *  serrées / punit l'alignement approximatif », distinct du Traqueur (visée
 *  assistée) et de l'Éventail (couverture large). Ne change pas le DPS nominal. */
const perforant: WeaponDef = {
  id: 'perforant',
  name: 'Perforant',
  modifiers: [
    // Change la NATURE du projectile — perforant — sans toucher au DPS nominal
    // (le mode n'entre pas dans `dps()`).
    { stat: Stat.BulletMode, op: 'add', value: PbMode.Pierce },
    // Contrepartie : un round 25 % plus fin, moins tolérant sur l'alignement
    // d'une file — précisément ce dont la perforation dépend.
    { stat: Stat.BulletRadius, op: 'mul', value: -0.25 },
  ],
  text: '10 volées/s × 2 × 10 dégâts — 200 DPS, rounds PERFORANTS et plus fins',
};

export default perforant;
